//TODO: add checkbox and event type filter to the filter component
import React, { useState } from 'react';
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";

interface EventTypeFilterProps {
    eventTypes: string[];
    checkedEventTypes: string[];
    onEventTypeFilterChange: (selectedTypes: string[]) => void;
}

const EventTypeFilter: React.FC<EventTypeFilterProps> = ({ eventTypes, onEventTypeFilterChange, checkedEventTypes }) => {

    const handleCheckboxChange = (eventType: string) => {
        const updatedSelectedTypes = checkedEventTypes.includes(eventType)
            ? checkedEventTypes.filter((type) => type !== eventType)
            : [...checkedEventTypes, eventType];

        onEventTypeFilterChange(updatedSelectedTypes);
    };

    return (
        <div>
            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 500 }}>
               <div className="filter-header-event-type">
               Event type
                </div>  
            </Typography>
            <FormGroup>
                {eventTypes.map((eventType) => (
                    <FormControlLabel
                        className="event-type-checkbox-label"
                        key={eventType}
                        control={
                            <Checkbox
                                checked={checkedEventTypes.includes(eventType)}
                                onChange={() => handleCheckboxChange(eventType)}
                                color="primary"
                            />
                        }
                        label={<span className="event-type-checkbox-label-text">{eventType}</span>}
                    />
                ))}
            </FormGroup>
        </div>
    );
};

export default EventTypeFilter;
